"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

require("core-js/modules/es7.symbol.async-iterator");

require("core-js/modules/es6.symbol");

require("core-js/modules/es6.object.define-property");

require("core-js/modules/es6.object.create");

require("core-js/modules/es6.regexp.to-string");

require("core-js/modules/es6.date.to-string");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.reflect.construct");

require("core-js/modules/es6.object.set-prototype-of");

require("core-js/modules/es6.function.bind");

require("core-js/modules/es6.regexp.replace");

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _analytics = _interopRequireDefault(require("@nerdwallet/analytics"));

var _impression = require("@nerdwallet/analytics/react/impression");

var _deprecate = require("@nerdwallet/deprecate");

var _reactPopover = _interopRequireDefault(require("@nerdwallet/react-popover"));

var _Help = _interopRequireDefault(require("@nerdwallet/react-icon/nerdwallet-ui/Help"));

var _tracking = require("@nerdwallet/nw-client-lib/tracking");

var _helpBubbleModule = _interopRequireDefault(require("./help-bubble.module.less"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var buildEntityName = function buildEntityName(entityName) {
  return entityName.toLowerCase().replace(/ |\W/g, '_').substring(0, 64);
};

var HelpBubble = /*#__PURE__*/function (_React$Component) {
  _inherits(HelpBubble, _React$Component);

  var _super = _createSuper(HelpBubble);

  function HelpBubble(props) {
    var _this;

    _classCallCheck(this, HelpBubble);

    _this = _super.call(this, props);
    _this.trackElementInteraction = _this.trackElementInteraction.bind(_assertThisInitialized(_this));
    _this.trackEventIn = _this.trackEventIn.bind(_assertThisInitialized(_this));
    _this.trackEventOut = _this.trackEventOut.bind(_assertThisInitialized(_this));
    _this.trackImpression = _this.trackImpression.bind(_assertThisInitialized(_this));
    _this.trackImpressionOut = _this.trackImpressionOut.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(HelpBubble, [{
    key: "trackElementInteraction",
    value: function trackElementInteraction(isOut) {
      var _this$props = this.props,
          analytics = _this$props.analytics,
          enableAnalytics = _this$props.enableAnalytics,
          id = _this$props.id,
          impressionId = _this$props.impressionId;

      if (enableAnalytics || analytics) {
        var _this$context;

        var payload = {
          action: isOut ? 'close' : 'open',
          entity_name: buildEntityName((analytics === null || analytics === void 0 ? void 0 : analytics.entityName) || "help_bubble_".concat(id)),
          interaction_type: 'hover'
        };

        if (impressionId) {
          payload.impression_id = impressionId;
        } else if ((_this$context = this.context) === null || _this$context === void 0 ? void 0 : _this$context.impressionId) {
          payload.impression_id = this.context.impressionId;
        }

        _analytics["default"].track('element_interacted', payload);
      }
    }
  }, {
    key: "trackEventIn",
    value: function trackEventIn() {
      this.trackImpression();
      this.trackElementInteraction();
    }
  }, {
    key: "trackEventOut",
    value: function trackEventOut() {
      this.trackImpressionOut();
      this.trackElementInteraction(true);
    }
  }, {
    key: "trackImpressionOut",
    value: function trackImpressionOut() {
      if (this.props.enableTracking && typeof window !== 'undefined') {
        window.clearTimeout(this.trackImpressionTimeout);
      }
    }
  }, {
    key: "trackImpression",
    value: function trackImpression() {
      var _this2 = this;

      if (this.props.enableTracking && typeof window !== 'undefined') {
        // Just in case of... (should have been cleared by onMouseOut)
        window.clearTimeout(this.trackImpressionTimeout);
        this.trackImpressionTimeout = window.setTimeout(function () {
          (0, _tracking.formInputChanged)({
            formName: _this2.props.trackingFormName,
            fieldName: _this2.props.trackingFieldName
          });
        }, 1000);
      }
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/_react["default"].createElement(_reactPopover["default"], {
        id: this.props.id,
        className: this.props.className,
        popoverClassName: (0, _classnames["default"])([_helpBubbleModule["default"].popover, this.props.popoverClassName]),
        popoverContent: this.props.popoverContent,
        onClick: this.props.onClick,
        placement: this.props.placement
      }, /*#__PURE__*/_react["default"].createElement(_Help["default"], {
        className: _helpBubbleModule["default"].icon,
        onMouseOver: this.trackEventIn,
        onFocus: this.trackEventIn,
        onMouseOut: this.trackEventOut,
        onBlur: this.trackEventOut
      }));
    }
  }]);

  return HelpBubble;
}(_react["default"].Component); // eslint-disable-next-line react/static-property-placement -- directive added automatically by Shepherd migration


_defineProperty(HelpBubble, "contextType", _impression.ImpressionContext);

HelpBubble.propTypes = {
  id: _propTypes["default"].string.isRequired,
  analytics: _propTypes["default"].shape({
    entityName: _propTypes["default"].string
  }),
  className: _propTypes["default"].string,
  enableAnalytics: _propTypes["default"].bool,
  enableTracking: _propTypes["default"].bool,
  trackingFormName: _propTypes["default"].string,
  trackingFieldName: _propTypes["default"].string,
  impressionId: _propTypes["default"].string,
  popoverClassName: _propTypes["default"].string,
  popoverContent: _propTypes["default"].node,
  onClick: _propTypes["default"].func,
  placement: _propTypes["default"].oneOf(['top', 'right', 'bottom', 'left'])
}; // eslint-disable-next-line react/static-property-placement -- directive added automatically by Shepherd migration

HelpBubble.defaultProps = {
  enableTracking: false,
  placement: 'top'
}; // eslint-disable-next-line react/static-property-placement -- directive added automatically by Shepherd migration

HelpBubble.displayName = 'HelpBubble';

var _default = (0, _deprecate.withDeprecatedPropsWarning)([{
  version: '7.8.0',
  deprecated: 'enableAnalytics',
  migration: 'use analytics prop instead. Empty object means disabled.'
}, {
  version: '7.8.0',
  deprecated: 'impressionId',
  migration: 'No longer need to pass this prop into the component.'
}])((0, _deprecate.withDeprecatedComponentWarning)({
  version: '7.8.2',
  migration: 'Use <Tooltip /> from `@nerdwallet/react-tooltip` instead.'
})(HelpBubble));

exports["default"] = _default;